import { AnalyticsV2Event, TelemetryEvent } from './types';

export const isAnalyticsV2Event = (event: TelemetryEvent): event is AnalyticsV2Event => event.type === 'AnalyticsV2';
